<template>
  <div>
    <v-layout column>
      <v-flex md4 class="pl-2">
        <label class="cmr-label-text">Associate Driver</label>
      </v-flex>
      <v-flex xs12 md8 pb-4>
        <v-layout align-center justify-start row>
          <v-autocomplete
              v-model="driverStore"
              :error-messages="errorForField()"
              :items="driversSearch"
              :loading="loading"
              :search-input.sync="search"
              item-text="callsign"
              dense
              outlined
              placeholder="Search by callsign of driver name or email address"
              hide-no-data
              hide-selected
              no-filter
              clearable
              return-object
              :disabled="false"
              hide-details
              @input="handleSelected"
              class="text-none mr-2"
          >
            <template v-slot:item="{ item }">
              {{ item.callsign }} | {{ item.user.name }} | {{ item.user.email }}
            </template>
          </v-autocomplete>
          <v-btn color="success" @click="associateDriver" class="text-none mr-2">Associate Driver</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-data-table
        style="width: 100%"
        :headers="headers"
        :items="drivers"
    >
      <template v-slot:item="props">
        <tr>
          <td style="width: 7%">{{ props.item.callsign }}</td>
          <td style="width: 7%">{{ props.item.user.name }}</td>
          <td style="width: 7%">{{ props.item.user.email }}</td>
          <td style="width: 25%">
            <v-row>
              <v-btn
                  @click="dissociateDriver(props.item.id)"
                  x-small
                  style=""
              >Remove Driver
              </v-btn>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>

  </div>
</template>


<script>

import axios from "axios";
import AttributesForTaxiCell from "@/components/widget/AttributesForTaxiCell.vue";

axios.defaults.withCredentials = true;

export default {
  name: "associated_drivers",
  components: {
    AttributesForTaxiCell,
  },
  props: {
    drivers: Array,
    taxi: Object,
    query: Object,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Callsign",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "document",
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "taxi",
        }
      ],
      driverStore: {},
      loading: false,
      driversSearch: [],
      search: null,
      selectedDriver: {}
    };
  },
  watch: {
    search(query) {
      this.resetError();

      if (query == null) return;
      if (query.length <= 2) return;
      if (this.loading) return;

      this.loading = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/driver/search?query=${query}`;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
          .then(function (res) {
            self.driversSearch = res.data.drivers;
            self.loading = false;
          })
          .catch(function (err) {
            console.error(err);
            self.loading = false;
          });
    }
  },
  mounted: async function () {
    this.getAssociatedDrivers();
  },
  computed: {},
  methods: {
    handleSelected: function () {
      this.selectedDriver = this.driverStore;
    },
    errorForField: function () {
      try {
        return this.errors["use_existing"];
      } catch (err) {
        return null;
      }
    },
    resetError: function () {
      try {
        if (this.errors["use_existing"] !== "") {
          this.errors["use_existing"] = "";
        }
      } catch (err) {
      }
    },
    associateDriver: async function () {
      let url = `${this.$store.state.apiUrl}/taxi/associate/driver?taxi_id=${this.taxi.id}&driver_id=${this.selectedDriver.id}`;

      try {
        let response = await axios.post(url, {
          params: {},
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });

        this.refresh();
      } catch (error) {
        console.log(error);
      }
    },
    dissociateDriver: async function (driverId) {
      let url = `${this.$store.state.apiUrl}/taxi/dissociate/driver?taxi_id=${this.taxi.id}&driver_id=${driverId}`;

      try {
        let response = await axios.post(url, {
          params: {},
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });

        this.refresh();
      } catch (error) {
        console.log(error);
      }
    },
    getAssociatedDrivers: async function () {
      this.loading = true;

      try {
        let url = `${this.$store.state.apiUrl}/taxi/driver/associatedDrivers/list?taxi_id=${this.taxi.id}`;

        console.log("getAssociatedDriverList: " + url);

        let response = await axios.get(url, {
          params: {},
        });

        this.drivers = response.data.drivers;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get associated drivers " + error);
      }
    },
    refresh: function () {
      this.getAssociatedDrivers();
    }
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 18px;
}
</style>
